import api from './client'

// EMP 900 — operatoria de gestión contra el ERP propio (lgr-erp, API v1) vía
// el gateway de LGR. Toda escritura lleva `uuid`: el formulario lo genera al
// abrirse y lo conserva entre reintentos, así el backend arma la MISMA
// Idempotency-Key y el ERP devuelve el mismo comprobante (repetida: true).
export const erpApi = {
  // Ventas
  comprobantes: (params = {}) => api.get('/emp900/ventas/comprobantes', { params }),
  comprobante: (id) => api.get(`/emp900/ventas/comprobantes/${id}`),
  facturar: (data) => api.post('/emp900/ventas/facturas', data),
  remitir: (data) => api.post('/emp900/ventas/remitos', data),
  facturarYRemitir: (data) => api.post('/emp900/ventas/facturar-y-remitir', data),
  cobrar: (data) => api.post('/emp900/ventas/recibos', data),
  notaCredito: (data) => api.post('/emp900/ventas/notas-credito', data),
  devolucion: (data) => api.post('/emp900/ventas/devoluciones', data),
  anularVenta: (id, data) => api.post(`/emp900/ventas/comprobantes/${id}/anular`, data),

  // Compras
  pedir: (data) => api.post('/emp900/compras/pedidos', data),
  recibir: (data) => api.post('/emp900/compras/recepciones', data),
  facturarCompra: (data) => api.post('/emp900/compras/facturas', data),
  notaCreditoCompra: (data) => api.post('/emp900/compras/notas-credito', data),
  pagar: (data) => api.post('/emp900/compras/pagos', data),
  gasto: (data) => api.post('/emp900/compras/gastos', data),
  anularFacturaCompra: (id, data) => api.post(`/emp900/compras/facturas/${id}/anular`, data),
  anularRecepcion: (id, data) => api.post(`/emp900/compras/recepciones/${id}/anular`, data),
  anularPago: (id, data) => api.post(`/emp900/compras/pagos/${id}/anular`, data),

  // Terceros (maestro del ERP)
  terceros: (params = {}) => api.get('/emp900/terceros', { params }),
  catalogosTerceros: () => api.get('/emp900/terceros/catalogos'),
  crearTercero: (data) => api.post('/emp900/terceros', data),

  // Consultas
  cuenta: (terceroId, tipo = 'cliente') => api.get(`/emp900/terceros/${terceroId}/cuenta`, { params: { tipo } }),
  depositos: () => api.get('/emp900/stock/depositos'),
  saldos: (params = {}) => api.get('/emp900/stock/saldos', { params }),
  registro: (params = {}) => api.get('/emp900/registro', { params }),
  // Precio sugerido (lista LISTALM de LGR) por sku — solo ventas de la 900
  precios: (skus) => api.get('/emp900/precios', { params: { skus: skus.join(',') } }),
}
